import { logEvent } from "firebase/analytics";
import React from "react";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AppContext from "../../components/app-context/AppContext";

import LinkContainer from "../../components/link-container";
import useFetch from "../../hooks/useFetch";
import UserGroupList from "../../pageComponents/usergroupList/UserGroupList";
import { RootState } from "../../services/reducers";
import { useVersionRetrieveQuery } from "../../services/reducers/version/versionSlice";
import { analytics } from "../../thirdparty/firebaseInit";

const HomePage = () => {
    const { loader } = useSelector(({ loader }: RootState) => loader);
    const { data, error, isLoading } = useVersionRetrieveQuery('');
    // const { data, error } = useFetch<any[]>("/api/version");
    const dispatch = useDispatch();
    const { version, loggedInUser } = React.useContext(AppContext);

    const navigate = useNavigate();

    React.useEffect(() => {
        logEvent(analytics, "page_view_effect");
    }, []);

    const handleClick = () => {
        navigate("/dashboard");
    }

    return (
        <div
            className="d-flex"
        >
            <div>
                <div>
                    <h2>Home</h2>
                    <p>{`${data}`}</p>
                </div>
                <Button
                    onClick={handleClick}
                >
                    Click
                </Button>
                <LinkContainer to="/foo/bar">
                    <Button>Foo</Button>
                </LinkContainer>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/about">About</Link>
                    </li>
                    <li>
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li>
                        <Link to="/nothing-here">Nothing Here</Link>
                    </li>
                </ul>
                {!!error && <p>There is an error.</p>}
                <p>{version}</p>
                <p>{`${loader}`}</p>
                <p>{`${loggedInUser?.displayName}`}</p>
                <UserGroupList
                />
            </div>
        </div>
    )
}

export default HomePage;
